const isPhoneValid = (phone) => {
  const regEx = /\+?\(?\d{2,4}\)?[\d\s-]{5,}/;
  return regEx.test(phone);
};

const isNitValid = (nit) => {
  const regEx = /(^[0-9]+-{1}[0-9]{1})/
  return regEx.test(nit)
}

const isCodeValid = (code) => {
  const regEx = /^[1-9]\d{1,9}$/
  return regEx.test(code)
}

const isEmailValid = (email) => {
  const regEx = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  return regEx.test(email);
};

const isMaxHourValid = (hours) => {
  const regEx = /^[0-9]\d{0,2}$/
  return regEx.test(hours)
}

export {
  isMaxHourValid,
  isPhoneValid,
  isEmailValid,
  isCodeValid,
  isNitValid,
}